export default __webpack_public_path__ + "static/media/onro-logotype.e17e8a08.svg";